import { json, postBiz } from '../core/coreapi';

const SERVICE = 'determinantreport';

/**
 * Generate the Determinant Report package (Tables 4–18).
 * Current DB generates the report as one governed package; it does not yet
 * support selective-table regeneration.
 */
export const generateDeterminantReport = async (
  determinantbudgetid: number,
) =>
  json(
    await postBiz({
      s: SERVICE,
      a: 'generate',
      dbi: determinantbudgetid,
    })
  );

/**
 * Fetch one generated report table.
 * Current DB returns the table payload stored under reportpayload[tablecode].
 */
export const fetchDeterminantReportTable = async (
  determinantbudgetid: number,
  tablecode: string,
): Promise<any> =>
  json(
    await postBiz({
      s: SERVICE,
      a: 'table',
      dbi: determinantbudgetid,
      tbc: tablecode,
    })
  );

export const validateDeterminantReport = async (
  determinantbudgetid: number,
) =>
  json(
    await postBiz({
      s: SERVICE,
      a: 'validate',
      dbi: determinantbudgetid,
    })
  );

export const certifyDeterminantReport = async (
  determinantbudgetid: number,
  notes: string,
) =>
  json(
    await postBiz({
      s: SERVICE,
      a: 'certify',
      dbi: determinantbudgetid,
      nts: notes,
    })
  );

export const revokeDeterminantReportCertification = async (
  determinantbudgetid: number,
  reason: string,
) =>
  json(
    await postBiz({
      s: SERVICE,
      a: 'revokecertification',
      dbi: determinantbudgetid,
      rsn: reason,
    })
  );
